export type GuestAcquisitionCtaMode = "testflight" | "app_store" | "download";

export interface GuestAcquisitionCtaConfig {
  mode: GuestAcquisitionCtaMode;
  url: string;
  titleKey: string;
  bodyKey: string;
  buttonKey: string;
}

const DEFAULT_CTA_MODE: GuestAcquisitionCtaMode = "download";
const DEFAULT_CTA_URL = "/download";

const acquisitionCopyKeys: Pick<
  GuestAcquisitionCtaConfig,
  "titleKey" | "bodyKey" | "buttonKey"
> = {
  titleKey: "sharedGroceryList.cta_app_store_title",
  bodyKey: "sharedGroceryList.cta_app_store_body",
  buttonKey: "sharedGroceryList.cta_app_store_button",
};

const isGuestAcquisitionCtaMode = (
  value: string | undefined,
): value is GuestAcquisitionCtaMode =>
  value === "testflight" || value === "app_store" || value === "download";

export const getGuestAcquisitionCtaConfig = (): GuestAcquisitionCtaConfig => {
  const configuredMode = import.meta.env.VITE_GUEST_ACQUISITION_CTA_MODE;
  const mode = isGuestAcquisitionCtaMode(configuredMode)
    ? configuredMode
    : DEFAULT_CTA_MODE;
  const configuredUrl = import.meta.env.VITE_GUEST_ACQUISITION_CTA_URL?.trim();

  return {
    mode,
    url: configuredUrl || DEFAULT_CTA_URL,
    ...acquisitionCopyKeys,
  };
};
